/**
 * masc.ts — Categoría "Mascotas" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_masc",
  skuPrefix: "MAS",
  categoria: "Mascotas",
} as const;

export const cat_masc_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Concentrado Pedigree Adulto 15kg",
    marca: "Pedigree",
    modelo: "Adultos Carne",
    origen: "Colombia",
    costo: 78500,
    precio: 119000,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "bolsa",
    ubicacionFisica: "Bodega M1",
    pesoNeto: "15kg",
    proveedor: "Mars Colombia",
    vencimientoMeses: 12,
    descripcionLarga:
      "Alimento completo y balanceado para perros adultos. Rico en proteína, vitaminas y minerales. Sabor carne, favorito canino.",
    especificaciones: [
      { clave: "Peso", valor: "15kg" },
      { clave: "Etapa", valor: "Adulto" },
    ],
    imageKeywords: ["dog-food", "pedigree", "dog-kibble"],
    color: "bg-amber-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Concentrado Whiskas Gato 3kg",
    marca: "Whiskas",
    modelo: "Adultos Pescado",
    origen: "Colombia",
    costo: 28500,
    precio: 44500,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "bolsa",
    ubicacionFisica: "Bodega M1",
    pesoNeto: "3kg",
    proveedor: "Mars Colombia",
    vencimientoMeses: 12,
    descripcionLarga:
      "Alimento balanceado para gatos adultos sabor pescado. Taurina y vitamina E para visión y corazón sanos.",
    especificaciones: [
      { clave: "Peso", valor: "3kg" },
      { clave: "Sabor", valor: "Pescado" },
    ],
    imageKeywords: ["cat-food", "whiskas", "cat-kibble"],
    color: "bg-purple-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Collar Ajustable Perro Mediano",
    marca: "RufflePaws",
    origen: "China",
    costo: 6500,
    precio: 10500,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "unidad",
    ubicacionFisica: "Estante M2, accesorios",
    proveedor: "Importaciones PetLife",
    material: "Nylon reforzado",
    colorProducto: "Azul",
    talla: "M (30-50cm)",
    descripcionLarga:
      "Collar ajustable de nylon con hebilla plástica resistente. Para perros medianos. Anillo metálico para placa.",
    especificaciones: [
      { clave: "Material", valor: "Nylon" },
      { clave: "Ajuste", valor: "30-50cm" },
    ],
    imageKeywords: ["dog-collar", "pet-collar", "dog-accessory"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Correa Retráctil 5m",
    marca: "Flexi",
    modelo: "New Classic M",
    origen: "Alemania",
    costo: 45000,
    precio: 69500,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante M2",
    proveedor: "Flexi Leashes",
    garantia: "1 año",
    dimensiones: "5m de cordón",
    descripcionLarga:
      "Correa retráctil con cordón de 5m para perros hasta 25kg. Botón freno y bloqueo. Agarre ergonómico.",
    especificaciones: [
      { clave: "Longitud", valor: "5m" },
      { clave: "Peso máximo", valor: "25kg" },
    ],
    imageKeywords: ["dog-leash", "retractable-leash", "pet-walking"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Arena Aglutinante Gato 10kg",
    marca: "Ever Clean",
    origen: "EE.UU.",
    costo: 52500,
    precio: 79900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "bolsa",
    ubicacionFisica: "Bodega M1",
    pesoNeto: "10kg",
    proveedor: "Clorox Pet Products",
    descripcionLarga:
      "Arena aglutinante premium a base de bentonita. Control de olores 7 días, forma grumos sólidos fáciles de retirar.",
    especificaciones: [
      { clave: "Peso", valor: "10kg" },
      { clave: "Control olor", valor: "7 días" },
    ],
    imageKeywords: ["cat-litter", "clumping-litter", "cat-sand"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Juguete Pelota Kong Perro",
    marca: "Kong",
    modelo: "Classic M",
    origen: "EE.UU.",
    costo: 22500,
    precio: 34500,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Estante M3, juguetes",
    proveedor: "Kong Company",
    material: "Caucho natural",
    colorProducto: "Rojo",
    descripcionLarga:
      "Juguete clásico Kong de caucho resistente. Rellenable con premios. Reduce ansiedad y aburrimiento.",
    especificaciones: [
      { clave: "Material", valor: "Caucho natural" },
      { clave: "Talla", valor: "Mediano" },
    ],
    imageKeywords: ["kong-toy", "dog-toy", "rubber-ball"],
    color: "bg-red-600",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Cama para Mascota 70x50cm",
    marca: "PetComfort",
    origen: "China",
    costo: 38500,
    precio: 58900,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante M4",
    proveedor: "PetComfort Importaciones",
    material: "Felpa y algodón",
    dimensiones: "70x50x18cm",
    descripcionLarga:
      "Cama acolchada para perros o gatos medianos. Base antideslizante, forro removible y lavable.",
    especificaciones: [
      { clave: "Dimensiones", valor: "70x50x18cm" },
      { clave: "Lavable", valor: "Sí" },
    ],
    imageKeywords: ["pet-bed", "dog-bed", "cat-bed"],
    color: "bg-amber-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Comedero Doble Inoxidable",
    marca: "PetLife",
    origen: "China",
    costo: 15500,
    precio: 24500,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Estante M3",
    proveedor: "Importaciones PetLife",
    material: "Acero inoxidable",
    dimensiones: "30x15cm",
    descripcionLarga:
      "Comedero-bebedero doble en acero inoxidable con base antideslizante. Higiénico y duradero, capacidad 350ml/tazón.",
    especificaciones: [
      { clave: "Material", valor: "Acero inoxidable" },
      { clave: "Capacidad", valor: "350ml c/u" },
    ],
    imageKeywords: ["pet-bowl", "dog-feeder", "stainless-bowl"],
    color: "bg-slate-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Snack Pedigree DentaStix x28",
    marca: "Pedigree",
    modelo: "DentaStix M",
    origen: "Colombia",
    costo: 18500,
    precio: 28500,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "bolsa",
    ubicacionFisica: "Estante M5, snacks",
    proveedor: "Mars Colombia",
    vencimientoMeses: 18,
    pesoNeto: "720g",
    descripcionLarga:
      "Snack dental diario para perros, reduce sarro 80% en uso regular. 28 palitos, uno por día durante 4 semanas.",
    especificaciones: [
      { clave: "Unidades", valor: "28" },
      { clave: "Beneficio", valor: "Salud dental" },
    ],
    imageKeywords: ["dog-treats", "dentastix", "dog-snacks"],
    color: "bg-green-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Shampoo para Gato 300ml",
    marca: "Bozita",
    origen: "Suecia",
    costo: 18500,
    precio: 28500,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "botella",
    ubicacionFisica: "Estante V2",
    proveedor: "Bozita Colombia",
    vencimientoMeses: 36,
    pesoNeto: "300ml",
    descripcionLarga:
      "Shampoo suave específico para gatos. pH balanceado, aloe vera, deja pelaje brillante y sedoso. Sin parabenos.",
    especificaciones: [
      { clave: "Volumen", valor: "300ml" },
      { clave: "pH", valor: "Balanceado felino" },
    ],
    imageKeywords: ["cat-shampoo", "pet-grooming", "feline-care"],
    color: "bg-pink-300",
    shape: "square",
  }),
];
